export default function reportPackageConfigurationReportDirective() {
  return {
    template: require('./report-package-configuration-report.html'),
    controller: 'PRReportPackageConfigurationReportController',
    controllerAs: 'prReportPackageConfigurationReportVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackageId: '@',
      reportPackageConfigurationReport: '=',
    },
  };
}
